import type { DrawdownStatus, InstallmentStatus, MovementType } from '@paguz/contracts';
import type { BadgeProps } from '@paguz/ui';
import {
  BadgePercentIcon,
  HandCoinsIcon,
  RotateCcwIcon,
  ShieldCheckIcon,
  ShoppingBagIcon,
  SlidersHorizontalIcon,
  TriangleAlertIcon,
  type LucideIcon,
} from 'lucide-react';

type BadgeVariant = NonNullable<BadgeProps['variant']>;

/** Etiquetas es-CO (lenguaje del glosario) para tipos y estados de crédito. */
export const MOVEMENT_TYPE: Record<
  MovementType,
  { label: string; icon: LucideIcon; isCredit: boolean }
> = {
  PURCHASE: { label: 'Compra', icon: ShoppingBagIcon, isCredit: false },
  PAYMENT: { label: 'Pago', icon: HandCoinsIcon, isCredit: true },
  REFUND: { label: 'Devolución', icon: RotateCcwIcon, isCredit: true },
  REVERSAL: { label: 'Reverso', icon: RotateCcwIcon, isCredit: true },
  INTEREST: { label: 'Intereses', icon: BadgePercentIcon, isCredit: false },
  MORATORIUM: { label: 'Intereses de mora', icon: TriangleAlertIcon, isCredit: false },
  INSURANCE: { label: 'Seguro', icon: ShieldCheckIcon, isCredit: false },
  FEE: { label: 'Comisión', icon: BadgePercentIcon, isCredit: false },
  ADJUSTMENT: { label: 'Ajuste', icon: SlidersHorizontalIcon, isCredit: true },
};

export const DRAWDOWN_STATUS: Record<DrawdownStatus, { label: string; variant: BadgeVariant }> = {
  ACTIVE: { label: 'Al día', variant: 'success' },
  IN_DISPUTE: { label: 'En reclamo', variant: 'warning' },
  PARTIALLY_REVERSED: { label: 'Devolución parcial', variant: 'highlight' },
  REVERSED: { label: 'Devuelta', variant: 'secondary' },
  PAID_OFF: { label: 'Pagada', variant: 'secondary' },
  CHARGED_OFF: { label: 'Castigada', variant: 'danger' },
};

export const INSTALLMENT_STATUS: Record<
  InstallmentStatus,
  { label: string; variant: BadgeVariant }
> = {
  SCHEDULED: { label: 'Programada', variant: 'outline' },
  BILLED: { label: 'Por pagar', variant: 'warning' },
  PARTIALLY_PAID: { label: 'Abonada', variant: 'highlight' },
  PAID: { label: 'Pagada', variant: 'success' },
  OVERDUE: { label: 'Vencida', variant: 'danger' },
  REVERSED: { label: 'Anulada', variant: 'secondary' },
};
